"use client";

import { useThemeEditor } from "@/components/theme-editor";
import type { FilesPageLayout } from "@/components/theme-editor/config";
import {
  CompactSidebarCategoryLayout,
} from "./layouts/CompactSidebarLayout";
import {
  SidebarCategoryLayout,
} from "./layouts/SidebarLayout";
import { TabsCategoryLayout } from "./layouts/TabsLayout";
import type { FileCategoryLayoutProps } from "./layouts/types";

function resolveLayout(layout: FilesPageLayout | undefined): FilesPageLayout {
  return layout ?? "sidebar";
}

export function FileCategoryContent(props: FileCategoryLayoutProps) {
  const { config } = useThemeEditor();
  const layout = resolveLayout(config.pages.files?.layout);

  if (layout === "compactSidebar") {
    return <CompactSidebarCategoryLayout {...props} />;
  }
  if (layout === "tabs") {
    return <TabsCategoryLayout {...props} />;
  }
  return <SidebarCategoryLayout {...props} />;
}
